import { useState } from 'react'
import { Modal, Button, Group, Stack, Text, Alert, Loader } from '@mantine/core'
import { showNotification } from '../util/notifications'

export default function ConfirmModal(props) {

    const [loading, setLoading] = useState(false)
    const [errorMessage, setErrorMessage] = useState('')
    const { opened, onClose, text, confirmAction, confirmText, cancelAction, ...rest } = props

    async function cancel() {
        setLoading(false)
        await cancelAction?.()
        onClose()
    }

    async function performAction() {
        setLoading(true)
        try {
            const content = await confirmAction?.()
            setLoading(false)
            onClose()
            if (content)
                showNotification({ content })
        } catch (error) {
            setErrorMessage(error.message)
            setLoading(false)
        }
    }

    return (
        <Modal
            opened={opened}
            onClose={cancel}
            title="Confirm"
            centered
            {...rest}
            styles={{
                title: {
                    fontSize: '1.125rem',
                    fontWeight: 700,
                    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif'
                }
            }}
        >
            <Stack gap="md" style={{ marginTop: '1em' }}>
                {typeof text === 'string' ? <Text>{text}</Text> : text}

                {errorMessage && (
                    <Alert color="red" variant="light">
                        <Text size="sm">{errorMessage}</Text>
                    </Alert>
                )}

                <Group justify="flex-end" mt="xs">
                    {loading && <Loader size="sm" />}
                    <Button variant="default" onClick={cancel} disabled={loading}>
                        Cancel
                    </Button>
                    <Button onClick={performAction} loading={loading}>
                        {confirmText}
                    </Button>
                </Group>
            </Stack>
        </Modal>
    )
}